import { Checkbox, Box, useColorModeValue } from '@chakra-ui/react';

function CustomCheckbox({ label, description = '', isChecked, onChange }) {
  const lineHeight = description ? '1' : 'normal';
  const controlOffset = description ? '2px' : '0';
  return (
    <Checkbox
      alignItems="flex-start"
      sx={{ '.chakra-checkbox__control': { mt: controlOffset } }}
      isChecked={isChecked}
      onChange={onChange}
    >
      <Box lineHeight={lineHeight} fontWeight={description ? 'bold' : 'normal'}>
        {label}
      </Box>
      {description && (
        <Box
          lineHeight="normal"
          color={useColorModeValue('secondaryDark08', 'white')}
          mt="1"
        >
          {description}
        </Box>
      )}
    </Checkbox>
  );
}

export default CustomCheckbox;
